/**
 * Button variant styles for action buttons.
 */
export enum BarActionButtonType {
    /** Default button appearance (maps to 'outlined'). */
    Default = 'default',
    /** @deprecated Use `Outlined` instead. This will be automatically mapped to 'outlined'. */
    Stroked = 'stroked',
    /** @deprecated Use `Filled` instead. This will be automatically mapped to 'filled'. */
    Flat = 'flat',
    /** @deprecated Use `Filled` instead. This will be automatically mapped to 'filled'. */
    Raised = 'raised',
    /** Filled button appearance. */
    Filled = 'filled',
    /** Outlined button appearance. */
    Outlined = 'outlined',
    /** Tonal button appearance. */
    Tonal = 'tonal',
    /** Text button appearance. */
    Text = 'text'
}
